import { gsap } from 'gsap';
import { component } from 'picoapp';
import { disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';

class QuickSearch {
  constructor(el, ctx) {
    this.el = el;
    this.ctx = ctx;
    this.active = false;
    this.identifier = el.dataset.identifier;
    this.init();
    this.bindEvents();
  }
  init() {
    let wrapper = this.el;
    let backdrop = wrapper.querySelector('.backdrop');
    let innerWrapper = wrapper.querySelector('.QuickSearch__inner');
    let searchInput = innerWrapper.querySelector('input[name="q"]');
    this.tl = gsap.timeline({
      paused: true,
      onComplete: () => {
        this.active = true;
        disableBodyScroll(this.el.querySelector('.PredictiveSearch__dropdown'));
        searchInput.focus();
      },
      onReverseComplete: () => {
        this.active = false;
        clearAllBodyScrollLocks();
      },
    });

    this.tl.set(wrapper, { visibility: 'visible', zIndex: 90, immediateRender: false });
    this.tl.from(backdrop, { opacity: 0, duration: 0.2 });
    this.tl.from(innerWrapper, { yPercent: '-100', duration: 0.2 });
  }
  bindEvents() {
    this.ctx.on('QuickSearch', (state) => {
      if (state.identifier == this.identifier) {
        if (typeof this[state.action] === 'function') {
          this[state.action]();
        }
      }
    });
    document.addEventListener('keyup', (e) => {
      if (e.keyCode == 27 && this.active) {
        this.close();
      }
    });
  }
  toggle() {
    if (this.active) {
      this.close();
    } else {
      this.open();
    }
  }
  open() {
    if (!this.active) {
      this.tl.play();
      this.ctx.emit('openQuickSearch');
    }
  }
  close() {
    if (this.active) {
      this.tl.reverse();
      this.ctx.emit('closeQuickSearch');
    }
  }
}

export default component((node, ctx) => {
  new QuickSearch(node, ctx);
});
